import { render, staticRenderFns } from "./costBreakdown.vue?vue&type=template&id=f43a9bb4&scoped=true&"
import script from "./costBreakdown.vue?vue&type=script&lang=js&"
export * from "./costBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./costBreakdown.vue?vue&type=style&index=0&id=f43a9bb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43a9bb4",
  null
  
)

export default component.exports